// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__CEVEK","spin":"style_spin__P8isg"};